import React, {Component} from "react"
import PropTypes from "prop-types"
import styled from "styled-components"

import {Label3} from "@irati/ui/src/Labels"
import {greys} from "@irati/ui/src/global/colors"
import padding from "@irati/ui/src/global/padding"
import id from "@irati/utils/id"

const StyledLabel = styled(Label3)`
  background-color: ${greys.light};
  padding: 5px 10px;
  border-radius: ${padding.tiny};
  white-space: nowrap;
`


class PillBadge extends Component {
  static propTypes = {
    className: PropTypes.string,
    children: PropTypes.node.isRequired
  }
  static defaultProps = {
    className: null
  }

  render() {
    const {className, children} = this.props

    const idNamespace = id("PillBadge", this.props)

    return <StyledLabel id={idNamespace} className={className} bold uppercase>{children}</StyledLabel>
  }
}

export default PillBadge
